<template>
  <div class="mainFrameContainer">
    <div class="rightBox">
      <div class="rightListBox">
        <div class="box_title">
          <p class="title">我所属的财务组织</p>
        </div>
        <div class="rightLook">
          <div class="company" v-for="(company,index) in companyOrgs" :key="index">
            <ul>
              <li>
                <a class="select" @click="goProduct(index)">
                  <div class="button">点击进入</div>
                  <p>公司编码：<span>{{company.number}}</span></p>
                  <p>姓名：{{currentUser.person.name}}</p>
                  <p>公司全称：{{company.name}}</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters,mapMutations} from "vuex";

export default {
  data () {
    return {

    };
  },
  mounted() {
    // console.log(this.currentUser)
    // console.log(this.companyOrgs)
  },
  computed:{
    ...mapGetters(["companyOrgs"]),
    ...mapGetters(["currentUser"]),
    ...mapMutations(['SET_INDEX'])
  },
  methods: {
    //跳转到授权支付页面
    goProduct(index){
      this.$store.commit('SET_INDEX' , index);
      this.$router.push({path: '/finance/spay'})
    }
  }
};
</script>

<style lang="less" scoped>
div{
  display: block;
}
ul, li, a, p{
  padding: 0;
  margin: 0;
  list-style-type: none;
  text-decoration: none;
}
.mainFrameContainer {
  position: absolute;
  top: 20px;
  left: 10px;
  bottom: 0;
  right: 0;
  overflow: hidden;
  z-index: 4;
  overflow-y: auto;
}
.rightBox{
  width: auto;
}
.rightListBox{
  padding: 18px 30px 20px 20px;
}
.rightLook {
  margin-bottom: 10px;
  margin-top: 15px;
  width: 100%;
  color: #6a5c5c;
  font-size: 12px;
  display: block;
}
a{
  display: block;
  width: 365px;
  height: 176px;
  background: #FFFFFF;
  border:1px solid #E5E5E5;
  float:left;
  margin-right: 16px;
  margin-bottom: 16px;
}
a:hover{
  border-color: red;
}
p{
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 12px;
  padding-left: 30px;
  padding-right: 30px;
}
span{
  color: #ff1500;
}
.title {
  display: block;
  font-size: 24px;
  font-weight: bold;
  padding-left: 0;
}
.button{
  color: #FFFFFF;
  text-align: center;
  line-height: 30px;
  width: 100px;
  height: 30px;
  background: #BE1304;
  margin-bottom: 15px;
}
</style>
